
<div  class="val-onglet val-flex-conteneur val-flex-colonne"
      (click)="Selection()">
  <div  class="val-onglet-accent"
        [style.background-color]="couleurCss"
        [ngClass]="{'val-invisible': !onglet.selectionne}">
  </div>
  <div  class="val-onglet-contenu val-flex-1 val-flex-conteneur">
    <div class="val-onglet-icone"
         [ngClass]="{'val-invisible': !onglet.icone}">
      @if (onglet.iconeCouleur) 
      {
        <val-fonte-icone [style.color]="iconeCouleurCss"
        [iconeCss]="onglet.icone!"></val-fonte-icone>
      }
      @else 
      {
        <val-fonte-icone [iconeCss]="onglet.icone!"></val-fonte-icone>
      }
    </div>
    <div class="val-flex-1"></div>
    <val-simple-libelle class="val-onglet-libelle"
                        [libelle]="onglet.libelle"
                        [style.color]="couleurCss">
    </val-simple-libelle>
    @if (compteurLignes)
    {
      <val-simple-libelle class="val-onglet-compteur"
                          [libelle]="compteurLignes"
                          [style.color]="couleurCss">
      </val-simple-libelle>
    }
    <div  class="val-flex-1"></div>
    <div  class="val-onglet-icone-rafraichissement"
          (click)="Rafraichissement()">
      <val-fonte-icone iconeCss="fas fa-redo"></val-fonte-icone>
    </div>
  </div>
  <div  class="val-onglet-espace"
        [ngClass]="{'val-invisible': !onglet.selectionne}">
  </div>
</div>
